import { Link } from 'react-router-dom'

import { BASE_URL } from './constants'

export const HAZARD_MAP_URL = "https://www.horrycounty.org/gisweb/rest/services/Public/HazardsMap/MapServer"
export const NEARBY_DISTRICTS_URL = "https://www.horrycounty.org/gisweb/rest/services/Public/BeforeYourMove/MapServer"
export const SITE_PLANS_URL = "https://www.horrycounty.org/gisweb/rest/services/Public/HorryCountyGIS2/MapServer"

export const NEARBY_DISTRICT_LAYER_IDS = {
  FIRE_STATIONS: 0,
  PARKS_AND_RECREATION: 11,
  LIBRARIES: 1,
  HOSPITALS: 2,
  ELEMENTARY_SCHOOLS: 8,
  MIDDLE_SCHOOLS: 3,
  HIGH_SCHOOLS: 9,
  MUNICIPALITIES: 10,
  COUNTY_BOUNDARY: 6,
}

export const HAZARD_LAYER_IDS = {
  PROPOSED_FLOOD_ZONES: 8,
  CURRENT_FLOOD_ZONES: 13,
  FLORENCE_ROAD_CLOSURES: 0,
  MATTHEW_ROAD_CLOSURES: 1,
  ESTIMATED_HURRICANE_FLORENCE_FLOODING: 17,
  EVACUATION_ZONES: 2,
  STORM_SURGE: 3,
  STORMWATER_EASEMENT: 4,
  COUNTY_BOUNDARY: 15,


  HURRICANE_FLORENCE_FLOOD_INUNDATION: 5,
  HURRICANE_MATTHEW_FLOOD_INUNDATION: 6,
}

export const SUBLAYER_ANALYTICS_IDS = {
  HAZARDS: {
    PROPOSED_FLOOD_ZONES: 1,
    CURRENT_FLOOD_ZONES: 2,
    FLORENCE_ROAD_CLOSURES: 3,
    MATTHEW_ROAD_CLOSURES: 5,
    ESTIMATED_HURRICANE_FLORENCE_FLOODING: 20,
    EVACUATION_ZONES: 7,
    STORM_SURGE: 8,
    STORMWATER_EASEMENT: 9,
    COUNTY_BOUNDARY: 10,


    HURRICANE_FLORENCE_FLOOD_INUNDATION: 4,
    HURRICANE_MATTHEW_FLOOD_INUNDATION: 6,
  },
  NEARBY_DISTRICTS: {
    FIRE_STATIONS: 11,
    PARKS_AND_RECREATION: 19,
    LIBRARIES: 12,
    HOSPITALS: 13,
    ELEMENTARY_SCHOOLS: 14,
    MIDDLE_SCHOOLS: 15,
    HIGH_SCHOOLS: 16,
    MUNICIPALITIES: 18,
    COUNTY_BOUNDARY: 17,
  }
}

export const HAZARD_MAP = 0
export const NEARBY_DISTRICTS_MAP = 1

const MAP_DATA = [
  {
    title: "Hazards",
    description: 
      <span className="block">
         <Link to="/flood-info">Click here for more information.</Link>
        This map includes evacuation zones, storm surge areas, stormwater easements and drainage areas, 
        roadway impacts from recent storm events, the current and proposed FEMA flood zones, 
        and <a href={`${BASE_URL}HorryCounty_SFZ_MethodologyFinal.pdf`} target="_blank" rel="noreferrer" className="pdf">the supplemental flood zone</a>, which reflects flooding from Hurricane Florence, the highest flood of record in Horry County.
       
      </span>,
    url: HAZARD_MAP_URL,
    anchor: 'Hazards',
    sublayers: [
      {
        id: HAZARD_LAYER_IDS.PROPOSED_FLOOD_ZONES,
        analytics_id: SUBLAYER_ANALYTICS_IDS.HAZARDS.PROPOSED_FLOOD_ZONES
      },
      {
        id: HAZARD_LAYER_IDS.CURRENT_FLOOD_ZONES,
        analytics_id: SUBLAYER_ANALYTICS_IDS.HAZARDS.CURRENT_FLOOD_ZONES
      },
      {
        id: HAZARD_LAYER_IDS.FLORENCE_ROAD_CLOSURES,
        analytics_id: SUBLAYER_ANALYTICS_IDS.HAZARDS.FLORENCE_ROAD_CLOSURES
      },
      {
        id: HAZARD_LAYER_IDS.MATTHEW_ROAD_CLOSURES,
        analytics_id: SUBLAYER_ANALYTICS_IDS.HAZARDS.MATTHEW_ROAD_CLOSURES
      },
      {
        id: HAZARD_LAYER_IDS.ESTIMATED_HURRICANE_FLORENCE_FLOODING,
        analytics_id: SUBLAYER_ANALYTICS_IDS.HAZARDS.ESTIMATED_HURRICANE_FLORENCE_FLOODING
      },
      {
        id: HAZARD_LAYER_IDS.EVACUATION_ZONES,
        analytics_id: SUBLAYER_ANALYTICS_IDS.HAZARDS.EVACUATION_ZONES
      },
      {
        id: HAZARD_LAYER_IDS.STORM_SURGE,
        analytics_id: SUBLAYER_ANALYTICS_IDS.HAZARDS.STORM_SURGE
      },
      {
        id: HAZARD_LAYER_IDS.STORMWATER_EASEMENT,
        analytics_id: SUBLAYER_ANALYTICS_IDS.HAZARDS.STORMWATER_EASEMENT
      },
      {
        id: HAZARD_LAYER_IDS.COUNTY_BOUNDARY,
        analytics_id: SUBLAYER_ANALYTICS_IDS.HAZARDS.COUNTY_BOUNDARY
      },



      {
        id: HAZARD_LAYER_IDS.HURRICANE_FLORENCE_FLOOD_INUNDATION,
        analytics_id: SUBLAYER_ANALYTICS_IDS.HAZARDS.HURRICANE_FLORENCE_FLOOD_INUNDATION
      },
      {
        id: HAZARD_LAYER_IDS.HURRICANE_MATTHEW_FLOOD_INUNDATION,
        analytics_id: SUBLAYER_ANALYTICS_IDS.HAZARDS.HURRICANE_MATTHEW_FLOOD_INUNDATION
      },
    ]
  }, 
  {
    title: "Nearby Districts",
    description: `This map includes school districts, police precincts, fire rescue stations, county facilities, library locations, 
      hospital locations, utility providers and waste center locations.`,
    url: NEARBY_DISTRICTS_URL,
    anchor: 'NearbyDistricts',
    sublayers: [
      { // Fire stations
        id: NEARBY_DISTRICT_LAYER_IDS.FIRE_STATIONS,
        analytics_id: SUBLAYER_ANALYTICS_IDS.NEARBY_DISTRICTS.FIRE_STATIONS,
        popupTemplate: {
          title: "Fire Station",
          content: [
            {
              type: "fields",
              fieldInfos: [
                {
                  fieldName: "NAME",
                  label: "Name"
                },
                {
                  fieldName: "ADDRESS",
                  label: "Address"
                },
                {
                  fieldName: "CITY",
                  label: "City"
                },
                {
                  fieldName: "STATE",
                  label: "State"
                },
                {
                  fieldName: "ZIP",
                  label: "Zip Code"
                },
                {
                  fieldName: "PHONE",
                  label: "Phone Number"
                },
                {
                  fieldName: "STATIONTYPE",
                  label: "Station Type"
                },
                {
                  fieldName: "CAREERSTATUS",
                  label: "Career Status"
                }
              ]
            }
          ]
        }
      },
      { // Parks and Recreation
        id: NEARBY_DISTRICT_LAYER_IDS.PARKS_AND_RECREATION,
        analytics_id: SUBLAYER_ANALYTICS_IDS.NEARBY_DISTRICTS.PARKS_AND_RECREATION,
        popupTemplate: {
          title: "{Type}",
          content: [
            {
              type: "fields",
              fieldInfos: [
                {
                  fieldName: "Name",
                  label: "Name"
                },
                {
                  fieldName: "Address",
                  label: "Address"
                },
              ]
            }
          ]
        }
      },
      { // Libraries
        id: NEARBY_DISTRICT_LAYER_IDS.LIBRARIES,
        analytics_id: SUBLAYER_ANALYTICS_IDS.NEARBY_DISTRICTS.LIBRARIES,
        popupTemplate: {
          title: "Library",
          content: [
            {
              type: "fields",
              fieldInfos: [
                {
                  fieldName: "COMMONNAME",
                  label: "Name"
                },
                {
                  fieldName: "ADDRESS",
                  label: "Address"
                },
                {
                  fieldName: "CITY_ID",
                  label: "City"
                },
                {
                  fieldName: "PHONENUMBER",
                  label: "Phone Number"
                }
              ]
            }
          ]
        }
      },
      { // Hospitals
        id: NEARBY_DISTRICT_LAYER_IDS.HOSPITALS,
        analytics_id: SUBLAYER_ANALYTICS_IDS.NEARBY_DISTRICTS.HOSPITALS,
        popupTemplate: {
          title: "Hospital",
          content: [
            {
              type: "fields",
              fieldInfos: [
                {
                  fieldName: "COMMONNAME",
                  label: "Name"
                },
                {
                  fieldName: "ADDRESS",
                  label: "Address"
                },
                {
                  fieldName: "CITY_ID",
                  label: "City"
                },
                {
                  fieldName: "PHONENUMBER",
                  label: "Phone Number"
                }
              ]
            }
          ]
        }
      },
      { // Elementary Schools
        id: NEARBY_DISTRICT_LAYER_IDS.ELEMENTARY_SCHOOLS,
        analytics_id: SUBLAYER_ANALYTICS_IDS.NEARBY_DISTRICTS.ELEMENTARY_SCHOOLS,
        popupTemplate: {
          title: "Elementary School",
          content: [
            {
              type: "fields",
              fieldInfos: [
                {
                  fieldName: "school",
                  label: "Name"
                },
                // {
                //   fieldName: "STREET",
                //   label: "Address"
                // },
                // {
                //   fieldName: "CITY",
                //   label: "City"
                // },
                // {
                //   fieldName: "STATE",
                //   label: "State"
                // },
                // {
                //   fieldName: "ZIP",
                //   label: "Zip Code"
                // },
                {
                  fieldName: "url",
                  label: "Website"
                }
              ]
            }
          ]
        }
      },
      { // Middle Schools
        id: NEARBY_DISTRICT_LAYER_IDS.MIDDLE_SCHOOLS,
        analytics_id: SUBLAYER_ANALYTICS_IDS.NEARBY_DISTRICTS.MIDDLE_SCHOOLS,
        popupTemplate: {
          title: "Middle School",
          content: [
            {
              type: "fields",
              fieldInfos: [
                {
                  fieldName: "school",
                  label: "Name"
                },
                // {
                //   fieldName: "STREET",
                //   label: "Address"
                // },
                // {
                //   fieldName: "CITY",
                //   label: "City"
                // },
                // {
                //   fieldName: "STATE",
                //   label: "State"
                // },
                // {
                //   fieldName: "ZIP",
                //   label: "Zip Code"
                // },
                {
                  fieldName: "url",
                  label: "Website"
                }
              ]
            }
          ]
        }
      },
      { // High Schools
        id: NEARBY_DISTRICT_LAYER_IDS.HIGH_SCHOOLS,
        analytics_id: SUBLAYER_ANALYTICS_IDS.NEARBY_DISTRICTS.HIGH_SCHOOLS,
        popupTemplate: {
          title: "High School",
          content: [
            {
              type: "fields",
              fieldInfos: [
                {
                  fieldName: "school",
                  label: "Name"
                },
                // {
                //   fieldName: "STREET",
                //   label: "Address"
                // },
                // {
                //   fieldName: "CITY",
                //   label: "City"
                // },
                // {
                //   fieldName: "STATE",
                //   label: "State"
                // },
                // {
                //   fieldName: "ZIP",
                //   label: "Zip Code"
                // },
                {
                  fieldName: "url",
                  label: "Website"
                }
              ]
            }
          ]
        }
      },
      { // Municipalities
        id: NEARBY_DISTRICT_LAYER_IDS.MUNICIPALITIES,
        analytics_id: SUBLAYER_ANALYTICS_IDS.NEARBY_DISTRICTS.MUNICIPALITIES,
        popupTemplate: {
          title: "Municipality",
          content: [
            {
              type: "fields",
              fieldInfos: [
                {
                  fieldName: "NAME",
                  label: "Name"
                }
              ]
            }
          ]
        }
      },
      {
        id: NEARBY_DISTRICT_LAYER_IDS.COUNTY_BOUNDARY,
        analytics_id: SUBLAYER_ANALYTICS_IDS.NEARBY_DISTRICTS.COUNTY_BOUNDARY
      }
    ]
  }, 
  // {
  //   title: "Hazards 2",
  //   description: `Testing with more maps!`,
  //   url: HAZARD_MAP_URL
  // }, 
  // {
  //   title: "Hazards 3",
  //   description: `Even more maps!!`,
  //   url: HAZARD_MAP_URL
  // },
  // {
  //   title: 'Site Plans',
  //   description: `Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam
  //     nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam
  //     erat, sed diam voluptua. At vero eos et accusam et justo duo dolores
  //     et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est
  //     Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur
  //     sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore`,
  //   url: SITE_PLANS_URL
  // }
]

export default MAP_DATA